export default __webpack_public_path__ + "static/media/i171vp.cfe43372.webp";